import { render, staticRenderFns } from "./ChannelsAdd.vue?vue&type=template&id=57ecec4b&"
import script from "./ChannelsAdd.vue?vue&type=script&lang=js&"
export * from "./ChannelsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsAdd.vue?vue&type=style&index=0&id=57ecec4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports